import { postNotificationAdminBulk } from '@/services/api/requests/notifications';
import { TNotificationForm } from '@/validation/notification';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { ENotificationTargetTypes } from '@/constants/stringVars';

const useSendNotificationToOrganizations = (organizationIds: Array<string>, onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: async (form: TNotificationForm) => {
      const response = await postNotificationAdminBulk({
        form,
        options: {
          targetType: ENotificationTargetTypes.ORGANIZATIONS,
          organizationIds,
        },
      });
      return response;
    },
    onSuccess: () => {
      toast({
        title: 'Notification sent successfully',
        description: 'The notification has been sent to the selected organization(s).',
        status: 'success',
        duration: 3000,
      });

      onSuccessCallback?.();
    },
    onError: (error) => {
      toast({
        title: 'Error sending notification',
        description: error?.message || 'An error occurred while sending the notification.',
        status: 'error',
        duration: 3000,
      });
    },
  });

  return { mutate, isPending };
};

export default useSendNotificationToOrganizations;
